import { createColumnHelper } from '@tanstack/react-table';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAssignUserBroker } from '../../api/user';
import useToastNotification from '../useToastNotification';

const useBrokerUsersColumns = () => {
  const columnHelper = createColumnHelper();
  const { t } = useTranslation();
  const { isSuccess, isLoading, isError } = useAssignUserBroker();
  useToastNotification({
    isShow: isSuccess,
    loading: isLoading,
    messageKey: 'SuccessfullyUpdatedUser',
    variant: 'success',
  });

  useToastNotification({
    isShow: isError,
    loading: isLoading,
    messageKey: 'ErrorUpdatingUser',
    variant: 'error',
  });

  const columns = [
    columnHelper.accessor((_row, i) => i + 1, {
      id: 'index',
      cell: (info) => <Typography>{info.getValue()}</Typography>,
      header: () => (
        <Typography variant="body1" fontWeight={700}>
          #
        </Typography>
      ),
    }),
    columnHelper.accessor((row) => row.firstName, {
      id: 'firstName',
      cell: (info) => <Typography>{info.getValue()}</Typography>,
      header: () => (
        <Typography variant="body1" fontWeight={700}>
          {t('firstname')}
        </Typography>
      ),
    }),
    columnHelper.accessor((row) => row.lastName, {
      id: 'lastName',
      cell: (info) => <Typography>{info.getValue()}</Typography>,
      header: () => (
        <Typography variant="body1" fontWeight={700}>
          {t('lastname')}
        </Typography>
      ),
    }),
    columnHelper.accessor((row) => row.email, {
      id: 'email',
      cell: (info) => <Typography>{info.getValue()}</Typography>,
      header: () => (
        <Typography variant="body1" fontWeight={700}>
          {t('email')}
        </Typography>
      ),
    }),
    columnHelper.accessor((row) => row.phoneNumber, {
      id: 'phoneNumber',
      cell: (info) => <Typography>{info.getValue()}</Typography>,
      header: () => <Typography>{t('phone.number')}</Typography>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.zipCode, {
      id: 'zipCode',
      cell: (info) => <Typography>{info.getValue()}</Typography>,
      header: () => <Typography>{t('zip')}</Typography>,
      footer: (info) => info.column.id,
    }),
  ];
  return columns;
};

export default useBrokerUsersColumns;
